(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    const form = root.querySelector('form');
    if (!form) return;
    root.dataset.initialized = 'true';
    const submit = form.querySelector('[type="submit"]');
    function update() {
      const overflow = form.querySelector('#AC-pooltype')?.value === 'Überlaufbecken';
      const note = root.querySelector('[data-overflow-note]');
      if (note) note.hidden = !overflow;
      for (const field of form.querySelectorAll('[data-measure]')) {
        const raw = field.value.trim().replace(',', '.');
        const value = Number(raw);
        const valid = /^\d+(?:\.\d+)?$/.test(raw) && Number.isFinite(value) && (field.dataset.measure === 'zero' ? value >= 0 : value > 0) && value <= 50;
        field.setCustomValidity(raw && !valid ? root.dataset.invalidMeasure : '');
      }
    }
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('submit', event => {
      update();
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      if (submit) { submit.setAttribute('aria-busy', 'true'); submit.textContent = submit.dataset.submittingLabel; }
    });
    window.addEventListener('pageshow', () => {
      if (submit) { submit.removeAttribute('aria-busy'); submit.textContent = submit.dataset.submitLabel; }
      update();
    });
    update();
  }
  document.querySelectorAll('[data-ap-compact-enquiry]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ap-compact-enquiry]').forEach(init));
})();
